import { Pipe, PipeTransform } from '@angular/core';
import { timeOperation } from '../../mock-map/demo-utils/demo-timer';

@Pipe({
  name: 'mockOffsetTimeEdit',
})
export class MockOffsetTimeEditPipe implements PipeTransform {
  transform(
    timeValue: string,
    offsetOperations: '+' | '-',
    offsetMinutes: number = 0,
    offsetSeconds: number = 0
  ): unknown {
    if (!timeValue) return '';
    return timeOperation(
      offsetOperations,
      timeValue,
      offsetMinutes,
      offsetSeconds
    );
  }
}
